"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sortable = require("@dnd-kit/sortable");

var _utilities = require("@dnd-kit/utilities");

var _reactBaseTable = require("react-base-table");

var _RowdragndropGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/RowdragndropGreyOutline"));

var _FixleftcolumnGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/FixleftcolumnGreyOutline"));

var _FixrightcolumnGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/FixrightcolumnGreyOutline"));

var _input = _interopRequireDefault(require("../../input"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _context = require("../context");

var _actions = require("../actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SortableColumn = function SortableColumn(_ref) {
  var id = _ref.id,
      data = _ref.data;

  var _useTable = (0, _context.useTable)(),
      fireAction = _useTable.fireAction,
      responsive = _useTable.responsive;

  var title = data.title,
      draggable = data.draggable,
      togglable = data.togglable,
      fixable = data.fixable,
      hidden = data.hidden,
      frozen = data.frozen;
  var isLeftFixed = frozen && frozen === _reactBaseTable.Column.FrozenDirection.LEFT;
  var isRightFixed = frozen && frozen === _reactBaseTable.Column.FrozenDirection.RIGHT;

  var _useSortable = (0, _sortable.useSortable)({
    id: id
  }),
      listeners = _useSortable.listeners,
      setNodeRef = _useSortable.setNodeRef,
      transform = _useSortable.transform,
      transition = _useSortable.transition,
      attributes = _useSortable.attributes;

  var style = {
    transform: _utilities.CSS.Translate.toString(transform),
    transition: transition
  };
  var toggleVisible = (0, _react.useCallback)(function (event) {
    fireAction((0, _actions.toggleColumnVisibility)({
      key: id,
      status: !event.target.checked
    }));
  }, [fireAction, id]);
  var fixColumnToLeft = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    fireAction((0, _actions.toggleColumnFixed)({
      key: id,
      direction: _reactBaseTable.Column.FrozenDirection.LEFT
    }));
  }, [fireAction, id]);
  var fixColumnToRight = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    fireAction((0, _actions.toggleColumnFixed)({
      key: id,
      direction: _reactBaseTable.Column.FrozenDirection.RIGHT
    }));
  }, [fireAction, id]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-column",
    ref: setNodeRef,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-d-flex oui-align-items-center"
  }, /*#__PURE__*/_react["default"].createElement(_RowdragndropGreyOutline["default"], (0, _extends2["default"])({
    className: "oui-mr-2 oui-drag-handle",
    clickable: true
  }, draggable ? listeners : {}, draggable ? attributes : {}, {
    disabled: !draggable
  })), /*#__PURE__*/_react["default"].createElement(_input["default"], {
    type: "checkbox",
    label: title,
    disabled: !togglable,
    checked: !hidden,
    onChange: toggleVisible,
    "aria-label": "toggle-column-".concat(id)
  })), !responsive && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Freeze this column to left"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#fixleft",
    "aria-label": "Freeze column ".concat(title, " to the left"),
    role: "button",
    className: (0, _classnames["default"])("oui-mr-2", "oui-column-fixer", isLeftFixed && "oui-active"),
    disabled: !fixable,
    onClick: fixable ? fixColumnToLeft : null
  }, /*#__PURE__*/_react["default"].createElement(_FixleftcolumnGreyOutline["default"], {
    inheritFontColor: true
  }))), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Freeze this column to right"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#fixright",
    "aria-label": "Freeze column ".concat(title, " to the right"),
    role: "button",
    className: (0, _classnames["default"])("oui-column-fixer", isRightFixed && "oui-active"),
    disabled: !fixable,
    onClick: fixable ? fixColumnToRight : null
  }, /*#__PURE__*/_react["default"].createElement(_FixrightcolumnGreyOutline["default"], {
    inheritFontColor: true
  })))));
};

SortableColumn.propTypes = {
  id: _propTypes["default"].string,
  data: _propTypes["default"].object
};
var _default = SortableColumn;
exports["default"] = _default;